import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDarkTheme = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.4999 9.97159C16.5405 11.491 14.8464 12.5001 12.9167 12.5001C9.92512 12.5001 7.5 10.075 7.5 7.08343C7.5 5.1536 8.50922 3.45947 10.0287 2.50005C10.0191 2.50002 10.0096 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 9.99053 17.5 9.98106 17.4999 9.97159Z",
		stroke: "#71717A",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgDarkTheme);
export default ForwardRef;
